var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTempo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143 470 c-21 -8 -23 -16 -23 -80 0 -76 -17 -97 -22 -27 -2 34 -7 42 -23 42 -30 0 -32 -49 -3 -80 13 -14 29 -25 36 -25 9 0 12 -27 12 -99 0 -79 3 -100 15 -105 21 -8 45 3 45 20 0 8 5 14 10 14 6 0 10 -7 10 -15 0 -8 5 -15 10 -15 6 0 10 -15 10 -34 0 -21 6 -36 15 -40 28 -10 45 5 45 40 0 19 5 34 10 34 6 0 10 7 10 15 0 8 5 15 10 15 6 0 10 -6 10 -14 0 -17 24 -28 45 -20 12 5 15 26 15 105 0 72 3 99 13 99 6 0 22 11 35 25 29 31 27 80 -3 80 -16 0 -21 -8 -23 -42 -5 -70 -22 -49 -22 27 0 66 -1 71 -26 80 -31 12 -181 12 -211 0z m186 -16 c30 -6 31 -8 31 -60 l0 -54 -40 0 c-22 0 -40 3 -40 7 0 4 12 19 27 35 14 15 23 31 19 35 -4 5 -24 -11 -44 -35 -35 -40 -40 -42 -89 -42 l-53 0 0 54 c0 49 2 55 23 59 36 7 132 7 166 1z m29 -216 c-3 -79 -4 -82 -30 -89 -23 -6 -28 -3 -37 22 -8 24 -16 29 -41 29 -25 0 -33 -5 -41 -29 -9 -25 -14 -28 -37 -22 -26 7 -27 10 -30 89 l-3 82 111 0 111 0 -3 -82z m-84 -80 c10 -41 7 -48 -24 -48 -31 0 -34 7 -24 48 8 29 40 29 48 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 285 c-4 -9 -2 -21 4 -27 15 -15 44 -1 40 19 -4 23 -36 29 -44 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 285 c-4 -9 -2 -21 4 -27 15 -15 44 -1 40 19 -4 23 -36 29 -44 8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempo);
export default __webpack_public_path__ + "static/media/tempo.4b1de5e84becb6ca378c55cad4dc607e.svg";
export { ForwardRef as ReactComponent };